
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai/warehouse-customer-service",
      function () {
        return require("private-next-pages/ai/warehouse-customer-service.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai/warehouse-customer-service"])
      });
    }
  